import {
  CONTACT_CHANNELS,
  LANGUAGES,
  NAV_ITEMS,
  SOCIAL_LINKS,
  awards,
  distinctions,
  domains,
  education,
  experience,
  expertise,
  expertiseStatement,
  projects,
  references,
  research,
  researchInterests,
  service,
  services,
  site,
  skillGroups,
  testimonials,
  tools,
} from '@/data'
import type { SiteContent } from './schema'

/**
 * What visitors see when the API has nothing stored, is unreachable, or was
 * never deployed. The site is fully functional on this alone — the admin only
 * ever supplies overrides on top.
 */
export const defaultContent: SiteContent = {
  site: { ...site },
  navItems: [...NAV_ITEMS],
  socialLinks: [...SOCIAL_LINKS],
  contactChannels: [...CONTACT_CHANNELS],
  languages: [...LANGUAGES],
  tools: [...tools],
  expertise: [...expertise],
  expertiseStatement,
  domains: [...domains],
  services: [...services],
  projects: [...projects],
  experience: [...experience],
  education: [...education],
  community: [...service],
  awards: [...awards],
  skillGroups: [...skillGroups],
  research: [...research],
  researchInterests: {
    heading: researchInterests.heading,
    summary: researchInterests.summary,
    areas: researchInterests.areas.map((a) => ({ ...a })),
  },
  distinctions: [...distinctions],
  references: [...references],
  testimonials: [...testimonials],
}
